// DesktopSidebar.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faSignOutAlt,
  faPlus,
  faRocket,
  faUserCircle,
  faLink,
  faSliders,
  faLayerGroup,
  faWandMagicSparkles,
  faBookmark,
} from "@fortawesome/free-solid-svg-icons";
import { faShopify } from "@fortawesome/free-brands-svg-icons";
import { faBell } from "@fortawesome/free-regular-svg-icons";
import logo from "assets/logo.png";

const DesktopSidebar = ({ user, activeStyle, inactiveStyle, handleLogout, unreadCount = 0, onOpenOnboarding }) => {
  const location = useLocation();
  return (
    <div className="hidden lg:flex w-1/6 flex-col justify-between">
      <div className="flex flex-col justify-between h-full">
        <div>
          <div className="flex items-center justify-between mb-4">
            <a href="https://onebotads.net" target="_blank" rel="noopener noreferrer">
              <img src={logo} alt="OnebotAds" className="h-8 hover:opacity-80 transition-opacity" />
            </a>
          </div>
          <div className="border-t-2 border-white mb-4"></div>
          <nav className="flex-1 space-y-2">
            <ul className="space-y-2">

              {/* OVERVIEW */}
              <li>
                <Link
                  to="/dashboard/statistics"
                  className={`flex items-center ${location.pathname === "/dashboard/statistics" ? activeStyle : inactiveStyle}`}
                >
                  <FontAwesomeIcon icon={faChartLine} className="mr-2 text-sm" />
                  <span className="text-sm">Overview</span>
                </Link>
              </li>

              {/* CAMPAIGNS */}
              <li className="border-t border-white/30 pt-2 mt-2">
                <Link
                  to="/dashboard/campaigns"
                  className={`flex items-center ${location.pathname === "/dashboard/campaigns" ? activeStyle : inactiveStyle}`}
                >
                  <FontAwesomeIcon icon={faLayerGroup} className="mr-2 text-sm" />
                  <span className="text-sm">Campaigns</span>
                </Link>
              </li>

              {/* CREATE */}
              <li className="border-t border-white/30 pt-2 mt-2">
                <Link
                  to="/dashboard/create-ad"
                  className={`flex items-center ${
                    location.pathname === "/dashboard/create-ad" || location.pathname === "/dashboard/create-ad-ai"
                      ? activeStyle
                      : inactiveStyle
                  }`}
                >
                  <FontAwesomeIcon icon={faPlus} className="mr-2 text-sm" />
                  <span className="text-sm">Create Ad</span>
                </Link>
              </li>
<li>
                <Link
                  to="/dashboard/ai-launcher"
                  className={`flex items-center ${location.pathname === "/dashboard/ai-launcher" ? activeStyle : inactiveStyle}`}
                >
                  <FontAwesomeIcon icon={faWandMagicSparkles} className="mr-2 text-sm" />
                  <span className="text-sm">AI Launcher</span>
                  <span className="ml-auto text-[9px] font-bold bg-gradient-to-r from-purple-500 to-pink-500 text-white px-1.5 py-0.5 rounded-full">NEW</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/dashboard/ad-library"
                  className={`flex items-center ${location.pathname === "/dashboard/ad-library" ? activeStyle : inactiveStyle}`}
                >
                  <FontAwesomeIcon icon={faBookmark} className="mr-2 text-sm" />
                  <span className="text-sm">Ad Library</span>
                </Link>
              </li>

              {/* AUTOMATE */}
              <li className="border-t border-white/30 pt-2 mt-2">
                <Link
                  to="/dashboard/ads-ruleset"
                  className={`flex items-center ${location.pathname === "/dashboard/ads-ruleset" ? activeStyle : inactiveStyle}`}
                >
                  <FontAwesomeIcon icon={faSliders} className="mr-2 text-sm" />
                  <span className="text-sm">Rules</span>
                </Link>
              </li>
              {/* ACCOUNT */}
              <li className="border-t border-white/30 pt-2 mt-2">
                <Link
                  to="/dashboard/connected-platforms"
                  className={`flex items-center ${location.pathname === "/dashboard/connected-platforms" ? activeStyle : inactiveStyle}`}
                >
                  <FontAwesomeIcon icon={faLink} className="mr-2 text-sm" />
                  <span className="text-sm">Platforms</span>
                </Link>
              </li>

              {/* NOTIFICATIONS + LOGOUT */}
              <li className="border-t border-white/30 pt-2 mt-2">
                <Link
                  to="/dashboard/notifications"
                  className={`flex items-center ${location.pathname === "/dashboard/notifications" ? activeStyle : inactiveStyle}`}
                >
                  <FontAwesomeIcon icon={faBell} className="mr-2 text-sm" />
                  <span className="text-sm">Notifications</span>
                  {unreadCount > 0 && (
                    <span className="ml-auto bg-[#221C51] text-white rounded-full px-2 py-0.5 text-xs font-bold">
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                  )}
                </Link>
              </li>
              <li>
                <button
                  onClick={() => handleLogout()}
                  className={`flex items-center ${inactiveStyle}`}
                >
                  <FontAwesomeIcon icon={faSignOutAlt} className="mr-2 text-sm" />
                  <span className="text-sm">Log Out</span>
                </button>
              </li>

            </ul>
          </nav>
        </div>
        {/* User Section */}
        <div className="mt-auto p-3 bg-[#0A1A58] bg-opacity-15 rounded-2xl shadow-lg flex flex-col items-start space-y-2 border border-[#0A1A58] relative w-full">
          <Link to="/dashboard/profile" className="flex items-center space-x-3 w-full hover:opacity-75 transition">
            <div className="relative">
              <FontAwesomeIcon icon={faUserCircle} className="text-3xl text-[#221C51]" />
              <span className="absolute bottom-0 right-0 bg-green-500 w-3 h-3 rounded-full border-2 border-white"></span>
            </div>
            <div className="flex flex-col">
              <p className="font-bold text-[#221C51] text-sm">{user.name}</p>
              <p className="text-xs text-[#221C51]">{user.email}</p>
            </div>
            <div className="ml-auto bg-[#221C51] text-white text-xs py-1 px-2 rounded-full absolute top-2 right-2">
              {user.isPremium ? "Premium" : "Basic"}
            </div>
          </Link>
          <Link
            to="/dashboard/billing"
            className="mt-2 w-full bg-[#F6F6F6] text-[#221C51] text-sm px-4 py-2 rounded-full hover:bg-gray-300 flex items-center justify-center transition ease-in-out duration-200"
          >
            <FontAwesomeIcon icon={faRocket} className="mr-2 text-base" />
            {user.isPremium ? 'Manage Billing' : 'Upgrade To Pro'}
          </Link>
          {onOpenOnboarding && (
            <button
              onClick={onOpenOnboarding}
              className="mt-1 w-full text-[#221C51]/50 text-xs hover:text-[#221C51] flex items-center justify-center gap-1 py-1 transition-colors"
            >
              <span>?</span>
              <span>Guide de démarrage</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DesktopSidebar;
